import { useLang } from "@/i18n";

const ITEM_KEYS = ["s1_t", "s2_t", "s3_t", "s4_t", "s5_t", "mq_strategy", "mq_content", "mq_growth"];

export default function Marquee() {
  const { t } = useLang();
  const row = [...ITEM_KEYS, ...ITEM_KEYS];
  return (
    <section data-testid="marquee-section" className="relative py-6 sm:py-8 border-y-2 border-[#2B0A4E] bg-[#2B0A4E] overflow-hidden -rotate-1 scale-[1.02]">
      <div className="marquee-track items-center gap-10 pr-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10 shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 shrink-0">
                <span className="font-serif-display italic text-2xl sm:text-3xl text-[#FDFBF5] whitespace-nowrap">
                  {t(item)}
                </span>
                <svg viewBox="0 0 24 24" className="w-4 h-4 shrink-0" fill="none" aria-hidden="true">
                  <path d="M12 2v20M2 12h20M5 5l14 14M19 5L5 19" stroke="#F2C230" strokeWidth="3" strokeLinecap="round" />
                </svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
